export const validateEmail = email => {
  // const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
    return ''
  }
  return 'Please enter a valid email address.'
}

export const validateName = name => {
  const re = /^[A-Za-z0-9\s]+$/
  if (re.test(name) || !name || name === '') {
    return ''
  }
  return 'Please do not enter special characterstics.'
}

export const validateRequired = (value, fieldName = null) => {
  if ((!value && value === '') || value === null) {
    return `${fieldName || 'value'} is required.`
  }
  return ''
}

export const validateRequiredField = (value, fieldName = null, type) => {
  let text = ''
  switch (type) {
    case 'string':
      text = 'enter'
      break
    case 'picklist':
    case 'select':
      text = 'select'
      break
    default:
      text = 'enter'
      break
  }

  if ((!value && (value === '' || value === null)) || (!value.name && (value.name === '' || value.name === null))) {
    return `Please ${text} ${fieldName || 'value'}.`
  }
  return ''
}

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
export const validateNumeric = (value, fieldName = null) => {
  // eslint-disable-next-line no-restricted-globals
  // biome-ignore lint/suspicious/noGlobalIsNan: TODO
  if (isNaN(value)) {
    return 'Please enter the Numeric value.'
  }
  return ''
}

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
export const validateFloat = (value, fieldName = null) => {
  const re = /^((\d+)((\.\d+)?))$/
  if (!re.test(value) || !value || value === '') {
    return 'Please enter valid integer or decimal number with 2 decimal places.'
  }
  return ''
}

export const validatePositiveNumber = (value, fieldName = null) => {
  const re = /^\d+$/
  if (!value || value === '') {
    return `Please enter  the ${fieldName || ''}.` // eslint-disable-line no-else-return
  }
  if (!re.test(value)) {
    return `Enter a value '0' or higher. Negative values cannot be used.`
  }
  return ''
}

export const validateFieldLength = (value, fieldName = null) => {
  if (value.length < 4 || value.length > 50) {
    return `${fieldName} should be at least 3 charector and at most 50 charector`
  }
  return ''
}

export const validateInputLength = (value, fieldName, minLength, maxLength, type) => {
  let label = ''

  switch (type) {
    case 'number':
      label = 'digits'
      break
    default:
      label = 'characters'
      break
  }
  if (minLength !== '' && maxLength === '' && value.length < minLength) {
    return `${fieldName} should be at least ${minLength} ${label}.`
  }
  if (minLength === '' && maxLength !== '' && value.length > maxLength) {
    return `${fieldName} should be at most ${maxLength} ${label}.`
  }
  if (minLength !== '' && maxLength !== '' && (value.length < minLength || value.length > maxLength)) {
    return `${fieldName} should be at least ${minLength} ${label} and at most ${maxLength} ${label}.`
  }

  return ''
}

export const validateMaxInputLengthOnly = (value, fieldName, max, type) => {
  let label = ''
  switch (type) {
    case 'number':
      label = 'digits'
      break
    default:
      label = 'characters'
      break
  }
  if (value.length > max) {
    return `${fieldName} should be at most ${max} ${label}`
  }
  return ''
}

export const validateOrganigation = (value, fieldName = null) => {
  if ((!value.name && value.name === '') || value.name === null) {
    return `Please enter the ${fieldName || 'positive value.'}`
  }
  return ''
}

export const validatePassword = value => {
  const charLength = value.length >= 8
  const numberEntered = !!value.match(/\d+/g)
  const capitalLetter = !!value.match(/[A-Z]/g)
  const specialChar = !!value.match(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/g)

  const passwordValid = charLength && numberEntered && capitalLetter && specialChar

  return {
    charLength,
    numberEntered,
    capitalLetter,
    specialChar,
    passwordValid,
  }
}
